import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class InventoryTransactionQueryCriteriaClass extends BaseCriteriaModel {
  //for line
  item_code?: Optional<string> = Optional.empty();

  //for ext
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();
}

export class InventoryTransactionCriteriaModelQuery {
  query = '';

  constructor(InventoryTransactionCriteriaModel: InventoryTransactionQueryCriteriaClass) {

    if (!InventoryTransactionCriteriaModel) {
      return;
    }

    this.query += InventoryTransactionCriteriaModel.item_code.filter(x => x !== '').map(x => '&item_code=' + x).orElse('');

    this.query += InventoryTransactionCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += InventoryTransactionCriteriaModel.updated_date.filter(x => x !== '').map(x => '&updated_date=' + x).orElse('');

    this.query += '&status=' + InventoryTransactionCriteriaModel.status;
    this.query += '&orderBy=' + InventoryTransactionCriteriaModel.orderBy;
    this.query += '&order=' + InventoryTransactionCriteriaModel.order;
    this.query += '&offset=' + InventoryTransactionCriteriaModel.offset + '&limit=' + InventoryTransactionCriteriaModel.limit;
  }
}
